<template>
  <div>
    <div class="modal-form">
      <div class="hint"></div>

      <div class="form-body">
        <div class="step-userinfo">
          <div>
            <Form ref="form">
              <WInput
                name="company_website"
                ref="formItem"
                :placeholder="$t('contactForm.lastForm.list')[0].placeholder"
                :error-text="$t('contactForm.lastForm.list')[0].error"
                v-model="formData.company_website"
                required
              />
              <WInput
                name="game_name"
                ref="formItem"
                :placeholder="$t('contactForm.lastForm.list')[1].placeholder"
                :error-text="$t('contactForm.lastForm.list')[1].error"
                v-model="formData.game_name"
                required
              />
              <WInput
                name="employee_number"
                ref="formItem"
                :placeholder="$t('contactForm.lastForm.list')[2].placeholder"
                :error-text="$t('contactForm.lastForm.list')[2].error"
                v-model="formData.employee_number"
                required
              />
              <WInput
                name="source"
                ref="formItem"
                :placeholder="$t('contactForm.lastForm.list')[3].placeholder"
                :error-text="$t('contactForm.lastForm.list')[3].error"
                v-model="formData.source"
                required
                :options="selectList"
                type="select"
              />
            </Form>
            <!-- <div class="input-box">
              <input v-model="formData.firstName" required type="text" />
              <span>{{ $t("contactForm.lastForm.list")[0].placeholder }}</span>
              <div v-if="error.firstName" class="error-text">
                {{ $t("contactForm.lastForm.list")[0].error }}
              </div>
            </div>

            <div class="input-box">
              <input v-model="formData.lastName" required type="text" />
              <span>{{ $t("contactForm.lastForm.list")[1].placeholder }}</span>
              <div v-if="error.lastName" class="error-text">
                {{ $t("contactForm.lastForm.list")[1].error }}
              </div>
            </div>

            <div class="input-box">
              <input v-model="formData.lastName" required type="text" />
              <span>{{ $t("contactForm.lastForm.list")[2].placeholder }}</span>
              <div v-if="error.lastName" class="error-text">
                {{ $t("contactForm.lastForm.list")[2].error }}
              </div>
            </div>

            <div class="input-box">
              <Select
                :placeholders="$t('contactForm.lastForm.list')[3].placeholder"
                :selectedValue="formData.position"
                size="small"
                :selectData="selectList"
                @change="selectChange"
              />
              <div v-if="error.position" class="error-text">
                {{ $t("contactForm.lastForm.list")[3].error }}
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="main-footer">
      <Button @click="next" size="small">{{ $t("contactForm.button.back") }}</Button>
      <Button @click="next" size="small">{{ $t("contactForm.button.submit") }}</Button>
    </div>
  </div>
</template>

<script>
// import Select from "@/components/Select/index.desktop";
import "../assets/index.desktop.scss";
import Button from "../../Button/button.desktop";
import WInput from "@/components/Input/index.desktop";
import Form from "@/components/Form/index";

export default {
  components: { WInput, Form, Button },
  data() {
    return {
      success: false,
      slectList: [],
      formData: {
        company_website: "",
        game_name: "",
        employee_number: "",
        source: "",
      },
      // 校验输入是否符合条件
    };
  },
  methods: {
    selectChange(_, value) {
      this.formData.position = value;
    },
    next() {
      const result = this.$refs.form.submit();

      if (result) this.$emit("nextForm", "third", this.formData);
    },
  },
  created() {
    this.selectList = this.$t("contactForm.lastForm.selectList").map(({ name, translate }) => ({
      name,
      value: translate,
    }));
  },
};
</script>

<style lang="scss" scoped>
.step-userinfo {
  .input-box {
    .error-text {
      top: 105%;
      left: 0;
    }
  }
}
</style>
